/**
 * Forces browsers to fetch a new copy when images/media are replaced in place at the same path.
 * Bump `assetsVersion` in AppData whenever you overwrite files under public/ (same filename).
 */
export function cacheBustMediaUrl(url, version) {
  if (url == null) return '';
  const s = String(url).trim();
  if (!s) return s;
  if (/^(data:|blob:)/i.test(s)) return s;
  if (version === undefined || version === null || version === '') return s;
  const v = String(version).trim();
  if (!v) return s;
  const sep = s.includes('?') ? '&' : '?';
  return `${s}${sep}v=${encodeURIComponent(v)}`;
}
